import {
  FolderOpen,
  Calendar,
  ClipboardList,
  BookOpen,
  FolderUp,
  Bed,
  Wrench,
  PiggyBank,
  Stethoscope,
  Building2,
  Printer,
  ShoppingCart,
} from "lucide-react";

/** Gradienti, icone e accenti: dashboard OSS e intestazioni di sezione */
export const ossSectionTheme = {
  fascicoli: {
    gradient: "from-purple-600 to-purple-800",
    Icon: FolderOpen,
    iconClass: "text-purple-600",
    titleClass: "text-purple-800",
    borderClass: "border-purple-800",
    accentBar: "bg-purple-500",
    accentSoft: "bg-purple-50",
  },
  camere: {
    gradient: "from-teal-500 to-teal-700",
    Icon: Bed,
    iconClass: "text-teal-600",
    titleClass: "text-teal-800",
    borderClass: "border-teal-800",
    accentBar: "bg-teal-500",
    accentSoft: "bg-teal-50",
  },
  turni: {
    gradient: "from-emerald-500 to-emerald-700",
    Icon: Calendar,
    iconClass: "text-emerald-600",
    titleClass: "text-emerald-800",
    borderClass: "border-emerald-800",
    accentBar: "bg-emerald-500",
    accentSoft: "bg-emerald-50",
  },
  primaNota: {
    gradient: "from-rose-500 to-rose-700",
    Icon: ClipboardList,
    iconClass: "text-rose-500",
    titleClass: "text-rose-800",
    borderClass: "border-rose-800",
    accentBar: "bg-rose-500",
    accentSoft: "bg-rose-50",
  },
  diarioConsegne: {
    gradient: "from-blue-500 to-blue-700",
    Icon: BookOpen,
    iconClass: "text-blue-600",
    titleClass: "text-blue-800",
    borderClass: "border-blue-800",
    accentBar: "bg-blue-500",
    accentSoft: "bg-blue-50",
  },
  documenti: {
    gradient: "from-amber-500 to-amber-700",
    Icon: FolderUp,
    iconClass: "text-amber-600",
    titleClass: "text-amber-800",
    borderClass: "border-amber-800",
    accentBar: "bg-amber-500",
    accentSoft: "bg-amber-50",
  },
  manutenzioni: {
    gradient: "from-orange-500 to-orange-700",
    Icon: Wrench,
    iconClass: "text-orange-600",
    titleClass: "text-orange-800",
    borderClass: "border-orange-800",
    accentBar: "bg-orange-500",
    accentSoft: "bg-orange-50",
  },
  risparmio: {
    gradient: "from-lime-500 to-emerald-700",
    Icon: PiggyBank,
    iconClass: "text-lime-600",
    titleClass: "text-lime-800",
    borderClass: "border-lime-800",
    accentBar: "bg-lime-500",
    accentSoft: "bg-lime-50",
  },
  medici: {
    gradient: "from-violet-500 to-violet-800",
    Icon: Stethoscope,
    iconClass: "text-violet-600",
    titleClass: "text-violet-800",
    borderClass: "border-violet-800",
    accentBar: "bg-violet-500",
    accentSoft: "bg-violet-50",
  },
  manutentori: {
    gradient: "from-orange-400 to-amber-700",
    Icon: Building2,
    iconClass: "text-amber-600",
    titleClass: "text-amber-800",
    borderClass: "border-amber-800",
    accentBar: "bg-amber-500",
    accentSoft: "bg-amber-50",
  },
  stampeMensili: {
    gradient: "from-sky-500 to-sky-800",
    Icon: Printer,
    iconClass: "text-sky-600",
    titleClass: "text-sky-800",
    borderClass: "border-sky-800",
    accentBar: "bg-sky-500",
    accentSoft: "bg-sky-50",
  },
  ordiniFarmacia: {
    gradient: "from-cyan-500 to-cyan-800",
    Icon: ShoppingCart,
    iconClass: "text-cyan-600",
    titleClass: "text-cyan-800",
    borderClass: "border-cyan-800",
    accentBar: "bg-cyan-500",
    accentSoft: "bg-cyan-50",
  },
};

/** Voci card dashboard: stessi colori delle pagine di sezione */
export const ossDashboardSections = [
  {
    sectionKey: "fascicoli",
    to: "/oss/fascicoli",
    title: "Fascicoli",
    subtitle: "Documentazione e cartelle",
  },
  {
    sectionKey: "camere",
    to: "/oss/camere",
    title: "Camere",
    subtitle: "Ospiti per camera",
  },
  {
    sectionKey: "turni",
    to: "/oss/turni",
    title: "Turni",
    subtitle: "Calendario e presenze",
  },
  {
    sectionKey: "primaNota",
    to: "/oss/prima-nota",
    title: "Prima Nota",
    subtitle: "Registro attività e note",
  },
  {
    sectionKey: "diarioConsegne",
    to: "/oss/diario-consegne",
    title: "Diario Consegne",
    subtitle: "Tracciamento consegne",
  },
  {
    sectionKey: "documenti",
    to: "/oss/documenti",
    title: "I miei documenti",
    subtitle: "Attestati, corsi e certificati",
  },
  {
    sectionKey: "stampeMensili",
    to: "/oss/stampe-mensili",
    title: "Stampe mensili",
    subtitle: "Alvo, docce, HACCP e registri",
    requiresResponsabile: true,
  },
  {
    sectionKey: "manutenzioni",
    to: "/oss/manutenzioni",
    title: "Manutenzioni",
    subtitle: "Richieste di intervento",
    requiresResponsabileManutenzioni: true,
  },
  {
    sectionKey: "risparmio",
    to: "/oss/risparmio",
    title: "Risparmio insieme",
    subtitle: "Listino e ordini",
    requiresResponsabile: true,
  },
  {
    sectionKey: "ordiniFarmacia",
    to: "/oss/ordini-farmacia",
    title: "Ordini farmacia",
    subtitle: "Extra blister alla farmacia",
    requiresResponsabile: true,
  },
  {
    sectionKey: "medici",
    to: "/oss/medici",
    title: "Medici",
    subtitle: "Anagrafica medici curanti",
    requiresResponsabile: true,
  },
  {
    sectionKey: "manutentori",
    to: "/oss/manutentori",
    title: "Manutentori",
    subtitle: "Fornitori e manutentori",
    requiresResponsabile: true,
  },
];
